/**
 * Route-scoped layout: mounts ClientsCacheProvider only for dashboard + clients list.
 */
import { Outlet } from 'react-router-dom';
import { ClientsCacheProvider } from '@/context/clients-cache-context';

export function ClientsCacheLayout() {
  return (
    <ClientsCacheProvider>
      <Outlet />
    </ClientsCacheProvider>
  );
}
